import Globals from "../../../globals/Globals";

export default {
    computed: {
        bookNowLabel() {
            if (Globals.isUsavePPAndPoaJourney(this.quote)) {
                return this.trans("booking-process.shared.pay_now_and_save_label");
            }
      
            return this.trans("booking-process.shared.book_now_button");
        },

        confirmAndPayOnCollectionLabel() {
            if (Globals.isUsavePPAndPoaJourney(this.quote)) {
                return this.trans("booking-process.payment.confirm_and_pay_at_pickup");
            }
      
            return this.trans("booking-process.payment.confirm_and_pay_collection_button");
        },

        payOnCollectionLabel() {
            if (Globals.isUsavePPAndPoaJourney(this.quote)) {
                return this.trans("booking-process.shared.pay_at_pick_up");
            }
      
            return this.trans("booking-process.shared.pay_on_collection_label");
        },

        totalToPayLabel() {
            if (Globals.isUsavePPAndPoaJourney(this.quote)) {
                return this.trans("booking-process.shared.pay_now_and_save_label");
            }
      
            return this.trans("booking-process.shared.total_to_pay");
        },
    },

    methods: {
        trans(key, replacements = {}, locale = null) {
            if (window['gmtrans']) {
                return gmtrans(key, replacements, locale);
            }
        },
        transChoice(key, number, replacements = {}, locale = null) {
            return Lang.choice(key, number, replacements, locale);
        },
    },
};
